export default function LotStackedBar({ segments, total, height = 8, className = '' }) {
  if (!total) return <span className="text-slate-300 text-xs">—</span>;
  return (
    <div
      className={`flex w-full rounded-sm overflow-hidden bg-slate-100 ${className}`}
      style={{ height }}
    >
      {segments.filter((s) => s.count > 0).map((s) => {
        const pct = (s.count / total) * 100;
        return (
          <div
            key={s.key}
            className={s.colorClass}
            style={{ width: `${pct}%` }}
            title={`${s.label} : ${s.count} (${Math.round(pct)} %)`}
          />
        );
      })}
    </div>
  );
}
